import { queryOptions, skipToken } from '@tanstack/react-query';

import {
  fetchIncomingInvoicesFilters,
  fetchIncomingInvoicesList,
  fetchIncomingInvoice,
  type FetchIncomingInvociesFiltersParams,
  type FetchIncomingInvoicesListParams
} from './requests';

export const incomingInvoiceQueries = {
  all: () => ['incoming-invoices'] as const,

  lists: () => [...incomingInvoiceQueries.all(), 'list'] as const,
  list: (params: FetchIncomingInvoicesListParams | null) =>
    queryOptions({
      queryKey: [...incomingInvoiceQueries.lists(), params],
      queryFn: params ? () => fetchIncomingInvoicesList(params) : skipToken
    }),
  filters: (params: FetchIncomingInvociesFiltersParams) =>
    queryOptions({
      queryKey: [...incomingInvoiceQueries.all(), 'filters', params],
      queryFn: params.columnName ? () => fetchIncomingInvoicesFilters(params) : skipToken
    }),

  details: () => [...incomingInvoiceQueries.all(), 'details'] as const,
  detail: (id: string) =>
    queryOptions({
      queryKey: [...incomingInvoiceQueries.details(), id],
      queryFn: () => fetchIncomingInvoice(id)
    })
};
